// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityOptions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');  
  var ObservablePropTypes = require('mobx-react').propTypes;
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');  
  var Password = require('./Izenda.Password');
  var SecurityQuestion = require('./Izenda.SecurityQuestion');
  var connect = require('share/enhancers/Izenda.Connect');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  
  var SecurityOptions = React.createClass({
    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentDidMount: function(){
      //this.props.store.populateTenantInfo();
    },

    render: function () {
      var store = this.props.store;
      var localization = this.props.localization;

      return (
        <div className="izenda-Wrapper izenda-UserProfile">
          <div className="izenda-Wrapper-header">
            <IconMenu />
            <div className='izenda-ActionBarLeft u_paddingTop'>
              <strong className='u_textUppercase'>{localization.getText("USER_MENU_MY_PROFILE")}
              </strong>
            </div>
          </div>
          <div className="izenda-Wrapper-content">
            <ScrollBox>
              <div className="u_paddingLeftRight">
                <GridLayout className="u_paddingAll u-bgWhite">
                  <Password store={store}></Password>
                  {store.model.numberOfQuestionProfile && <SecurityQuestion store={store}></SecurityQuestion>}
                </GridLayout>
              </div>
            </ScrollBox>
          </div>        
        </div>
      );
    }    
  });

  module.exports = connect()(SecurityOptions);
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/SecurityOptions/Izenda.SecurityOptions.jsx